import type { AdminStory } from '@erp/shared';

export type DisplayStatus = 'draft' | 'scheduled' | 'live' | 'expired' | 'archived';

/** Derive the shopper-facing status from the stored fields (no cron needed). */
export function displayStatus(s: Pick<AdminStory, 'status' | 'scheduledAt' | 'expiresAt'>): DisplayStatus {
  if (s.status === 'draft') return 'draft';
  if (s.status === 'archived') return 'archived';
  const now = Date.now();
  if (s.scheduledAt && new Date(s.scheduledAt).getTime() > now) return 'scheduled';
  if (s.expiresAt && new Date(s.expiresAt).getTime() <= now) return 'expired';
  return 'live';
}

export function statusTone(s: DisplayStatus): 'neutral' | 'success' | 'warning' | 'info' | 'danger' {
  switch (s) {
    case 'live': return 'success';
    case 'scheduled': return 'info';
    case 'expired': return 'warning';
    case 'archived': return 'neutral';
    default: return 'neutral';
  }
}
